export default "__VITE_ASSET__CRwaTjXb__"